
const VOD_TRIAL_ONBOARDING_STORAGE_PREFIX = '';
const VOD_TRIAL_ONBOARDING_STORAGE_KEY = 'vod-trial-onboarding';
const VOD_TRIAL_ONBOARDING_STORAGE = `${VOD_TRIAL_ONBOARDING_STORAGE_PREFIX}${VOD_TRIAL_ONBOARDING_STORAGE_KEY}`;

export const getOnboardingStorageKey = (orgId) => `${VOD_TRIAL_ONBOARDING_STORAGE}-${orgId}`;
